import { HttpHandler, HttpInterceptor, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

export class CompanyInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const selectedCompanyId = localStorage.getItem('selectedCompany');

    if (selectedCompanyId) {
      const cloned = request.clone({
        headers: request.headers.set('Company-Id',
          selectedCompanyId)
      });

      return next.handle(cloned);
    } else {
      return next.handle(request);
    }
  }
}
